import { FormLabel } from '@chakra-ui/form-control';

export const Label = FormLabel;
